"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RetailLocationCardBody = void 0;
const React = require("react");
const RetailLocationDetails_1 = require("../RetailLocationDetails");
const RetailLocationInfo_1 = require("../RetailLocationInfo");
const styles = require("./styles.scss");
const cssComposer_1 = require("../../../../../../helpers/cssComposer");
const css = (0, cssComposer_1.default)(styles, "RetailLocationCardBody");
const RetailLocationCardBody = ({ retailLocation, orderType, showInfo = false }) => (React.createElement("div", { className: css("") },
    React.createElement(RetailLocationDetails_1.RetailLocationDetails, { retailLocation: retailLocation }),
    showInfo && (React.createElement(RetailLocationInfo_1.RetailLocationInfo, { retailLocation: retailLocation, orderType: orderType }))));
exports.RetailLocationCardBody = RetailLocationCardBody;
//# sourceMappingURL=index.js.map